import {
  Alert,
  AlertColor,
  Autocomplete,
  Box,
  Stack,
  TextField,
} from "@mui/material";
import Button from "@mui/material/Button";
import { FormControl } from "@mui/material";
import { useState } from "react";
import { Option } from "../Utilities";
import { PostFormModel } from "../models/PostFormModel";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFnsV3";
import ErrorsString from "../ErrorsString";
import React from "react";
import { GetChannelsModel } from "../models/GetChannelsModel";
import config from "../config";
import { useNavigate } from "react-router-dom";

export default function FormPage() {
  const [seasonNumber, setSeasonNumber] = useState<number | null>(null);
  const [episodeNumber, setEpisodeNumber] = useState<number | null>(null);
  const [notes, setNotes] = useState<string>("");
  const [errorNotes, setErrorNotes] = useState<boolean>(false);
  const [helperTextNotes, setHelperTextNotes] = useState<string>("");
  const [txDate, setTxDate] = useState<Date | null>(null);

  const [title, setTitle] = useState<string>("");
  const [errorTitle, setErrorTitle] = useState<boolean>(false);
  const [helperTextTitle, setHelperTextTitle] = useState<string>("");

  const [needByDate, setNeedByDate] = useState<Date | null>(null);
  const [errorNeedByDate, setErrorNeedByDate] = useState<boolean>(false);
  const [helperTextNeedByDate, setHelperTextNeedByDate] = useState<
    string | null
  >("");

  let [contentTypeOptions, setContentTypeOptions] = useState<Option[]>([
    { label: config.contentType.Movie, id: config.contentTypeMapping.Movie },
    {
      label: config.contentType.Episode,
      id: config.contentTypeMapping.StandaloneEpisode,
    },
    { label: config.contentType.Season, id: config.contentTypeMapping.Season },
  ]);
  let [contentTypeSelected, setContentTypeSelected] = useState<Option | null>(
    null
  );
  const [errorContentType, setErrorContentType] = useState<boolean>(false);
  const [helperTextContentType, setHelperTextContentType] = useState<
    string | null
  >("");

  let [channelOptions, setChannelOptions] = useState<Option[]>([]);
  let [channelSelected, setChannelSelected] = useState<Option | null>(null);
  const [errorChannel, setErrorChannel] = useState<boolean>(false);
  const [helperTextChannel, setHelperChannel] = useState<string | null>("");

  const [isVisible, setIsVisible] = useState<boolean>(false);
  const [message, setMessage] = useState<string | null>("");
  const [severity, setSeverity] = useState<AlertColor>("success");

  let [alertMessage, setAlertMessage] = useState<string>("");
  let [showAlert, setShowAlert] = useState<boolean>(false);

  const navigate = useNavigate();

  React.useEffect(() => {
    setDefaultNeedByDate();
    getChannels();
  }, []);

  function setDefaultNeedByDate() {
    const today = new Date();
    const needByDate = new Date(today);
    needByDate.setMonth(today.getMonth() + 1);
    setNeedByDate(needByDate);
  }

  function getChannels() {
    console.log("Starting API call GetChannelsModel...");
    (async () => {
      const response = await GetChannelsModel();
      //console.log("GetChannelsModel response: " + JSON.stringify(response));

      const responseData = response?.data;
      const statusCode = response?.status;

      if (responseData === undefined) {
        setShowAlert(true);
        setAlertMessage("Error in retrieving channels");
        return;
      }

      if (statusCode !== 200) {
        setShowAlert(true);
        setAlertMessage("Error in retrieving channels");
        return;
      } else {
        setChannelOptions(responseData);
      }
    })();
  }

  function sendPostRequest() {
    //setSpinnerVisibility(true);
    let datetime = new Date();
    const created_on = datetime;

    let response = null;
    let responseData = null;
    let statusCode = null;

    console.log("Starting API call PostFormModel...");
    (async () => {
      response = await PostFormModel(
        created_on,
        title,
        channelSelected.label,
        contentTypeSelected.label,
        seasonNumber,
        episodeNumber,
        txDate,
        needByDate,
        notes
      );
      //console.log("PostFormModel response: " + JSON.stringify(response));

      responseData = response?.data;
      statusCode = response?.status;

      if (responseData === undefined) {
        setSeverity("error");
        setMessage(ErrorsString.errorMessageGeneric);
        setIsVisible(!isVisible);
        return;
      }

      if (statusCode == 200) {
        if (responseData.code !== "0") {
          setSeverity("error");
          setMessage("An error occurred while sending the request ");
          setIsVisible(!isVisible);
          return;
        } else {
          setSeverity("success");
          setMessage("Request Successfully sent!");
          setIsVisible(!isVisible);

          const timer = setTimeout(() => {
            navigate("/");
          }, 2000);
        }
      } else {
        setSeverity("error");
        setMessage(ErrorsString.errorMessageGeneric);
        setIsVisible(!isVisible);
        return;
      }
    })();
  }

  function containsHtml(input: string) {
    const div = document.createElement("div");
    div.innerHTML = input;
    return div.innerHTML !== input || /<\/?[a-z][\s\S]*>/i.test(input);
  }

  const handleRequest = () => {
    //controlla che i campi required non siano vuoti
    const isTitleEmpty = title === "" || title === null;

    const areRequiredNotEmpty =
      !isTitleEmpty &&
      channelSelected !== null &&
      contentTypeSelected !== null &&
      needByDate !== null;

    const areTitleSecurityChecksPassed = !containsHtml(title);
    const areNotesSecurityCHeckedPassed = !containsHtml(notes);

    const areSecurityChecksPassed =
      areTitleSecurityChecksPassed && areNotesSecurityCHeckedPassed;

    if (areRequiredNotEmpty && areSecurityChecksPassed) {
      sendPostRequest();
    } else {
      //if a field contains html, notify the user (notes: it is an additional check because the fields are sanified during input change)
      if (!areTitleSecurityChecksPassed) {
        setErrorTitle(true);
        setHelperTextTitle("Input not allowed: contains HTML code.");
      }
      if (!areNotesSecurityCHeckedPassed) {
        setErrorNotes(true);
        setHelperTextNotes("Input not allowed: contains HTML code.");
      }
      // per i campo required non compilati, segnala a gui l'errore
      if (title === "" || title === null) {
        setErrorTitle(true);
        setHelperTextTitle("Mandatory field");
      }
      if (channelSelected === null) {
        setErrorChannel(true);
        setHelperChannel("Mandatory field");
      }
      if (contentTypeSelected === null) {
        setErrorContentType(true);
        setHelperTextContentType("Mandatory field");
      }
      if (needByDate === null) {
        setErrorNeedByDate(true);
        setHelperTextNeedByDate("Mandatory field");
      }
    }
  };

  function sanitizeTextFromHtml(string) {
    //sanitize input
    string = string.replace(/<\/?[^>]+(>|$)/g, "");

    return string;
  }

  function handleNotes(notes) {
    notes = sanitizeTextFromHtml(notes);
    setNotes(notes);
  }

  function handleTitle(title) {
    title = sanitizeTextFromHtml(title);
    setTitle(title);
  }

  return (
    <div className="flex justify-center">
      {!showAlert ? (
        <Box
          className="p-5 mt-3 mr-2 ml-2 flex justify-center w-screen w-3/4 shadow-lg"
          sx={{ borderRadius: "16px" }}
        >
          <FormControl className="w-1/2">
            <div className="text-2xl font-bold mb-8 mt-5 text-center">
              New Request
            </div>

            <Autocomplete
              disablePortal
              disableClearable
              id="content-type"
              value={contentTypeSelected}
              options={contentTypeOptions}
              fullWidth
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Content Type"
                  required
                  error={errorContentType}
                  helperText={helperTextContentType}
                />
              )}
              onChange={(event: any, newContentTypeSelected: Option) => {
                setContentTypeSelected(newContentTypeSelected);
              }}
              sx={{ mb: 4 }}
            />

            <TextField
              id="title"
              type="text"
              variant="outlined"
              color="secondary"
              label="Programme Title"
              onChange={(e) => handleTitle(e.target.value)}
              value={title}
              fullWidth
              required
              error={errorTitle}
              helperText={helperTextTitle}
              sx={{ mb: 4 }}
            />

            <Autocomplete
              disablePortal
              disableClearable
              id="channel"
              value={channelSelected}
              options={channelOptions}
              fullWidth
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Channel"
                  error={errorChannel}
                  helperText={helperTextChannel}
                />
              )}
              onChange={(event: any, newChannelSelected: Option) => {
                setChannelSelected(newChannelSelected);
              }}
              sx={{ mb: 4 }}
            />

            <Stack spacing={2} direction="row" sx={{ marginBottom: 4 }}>
              <TextField
                id="season-number"
                type="number"
                variant="outlined"
                color="secondary"
                label="Season/Series Number"
                onChange={(e) => setSeasonNumber(Number(e.target.value))}
                value={seasonNumber != null ? seasonNumber : ""}
                fullWidth
                sx={{ mb: 4 }}
              />

              <TextField
                id="episode-number"
                type="number"
                variant="outlined"
                color="secondary"
                label="Episode Number"
                onChange={(e) => setEpisodeNumber(Number(e.target.value))}
                value={episodeNumber != null ? episodeNumber : ""}
                fullWidth
                sx={{ mb: 4 }}
              />
            </Stack>

            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <DatePicker
                label="Tx Date"
                value={txDate}
                onChange={(newValue) => {
                  setTxDate(newValue);
                }}
                sx={{ mb: 4 }}
                disablePast
                slotProps={{
                  textField: {
                    required: false,
                  },
                }}
              />
            </LocalizationProvider>

            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <DatePicker
                label="Need By Date"
                value={needByDate}
                onChange={(newValue) => {
                  setNeedByDate(newValue);
                }}
                sx={{ mb: 4 }}
                disablePast
                slotProps={{
                  textField: {
                    helperText: helperTextNeedByDate,
                    error: errorNeedByDate,
                    required: true,
                  },
                }}
              />
            </LocalizationProvider>

            <TextField
              id="notes"
              label="Notes"
              multiline
              rows={2}
              onChange={(e) => handleNotes(e.target.value)}
              value={notes}
              InputLabelProps={{
                shrink: true,
              }}
              error={errorNotes}
              helperText={helperTextNotes}
              sx={{ mb: 4 }}
            />

            <div className="flex  justify-between">
              <div className="message-box ">
                <div className={`${isVisible ? "visible" : "invisible"} `}>
                  <Alert severity={severity}>{message}</Alert>
                </div>
              </div>
              <Button
                variant="outlined"
                color="secondary"
                type="submit"
                onClick={handleRequest}
              >
                Send
              </Button>
            </div>
          </FormControl>
        </Box>
      ) : (
        <Alert
          severity="error"
          style={{
            display: showAlert ? "flex" : "none",
          }}
        >
          {alertMessage}
        </Alert>
      )}
    </div>
  );
}
